<template>
  <d2-container>
    <div class="mb-club">
      <el-form ref="clubSetting" :model="clubSetting" class="unify-box" label-width="auto">
          <p class="title">俱乐部转会设置</p>
          <el-row :gutter="24">
              <el-col :md="12" :sm="24">
                  <el-form-item label="转会时间段:">
                    <el-date-picker
                        v-model="clubSetting.time"
                        type="daterange"
                        size="mini"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间">
                    </el-date-picker>
                  </el-form-item>
              </el-col>
              <el-col :md="12" :sm="24">
                  <el-form-item label="转会次数:" class="number">
                    <el-input v-model="clubSetting.number" size="mini" placeholder="次数" @input="clubSetting.number = clubSetting.number.replace(/[^\d]/g, '')">></el-input>
                  </el-form-item>
              </el-col>
        </el-row>
        <div class="gap-top">
          <span class="label">允许会员新建俱乐部</span>
          <el-checkbox v-model="clubSetting.permit"></el-checkbox>
        </div>
      </el-form>
      <el-form ref="memberSetting" :model="memberSetting" class="unify-box" label-width="auto">
        <p class="title">会员转会设置</p>
        <el-row :gutter="24">
            <el-col :md="12" :sm="24">
                <el-form-item label="转会时间段:">
                    <el-date-picker
                      v-model="memberSetting.time"
                      type="daterange"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间">
                  </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :md="12" :sm="24">
                <el-form-item label="转会次数:" class="number">
                  <el-input v-model="memberSetting.number" size="mini" placeholder="次数" @input="memberSetting.number = memberSetting.number.replace(/[^\d]/g, '')"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <el-form ref="paySetting" :model="paySetting" :rules="payRules" class="unify-box" label-width="auto" :inline-message="true">
        <p class="title">转会缴费设置</p>
        <el-form-item prop="number">
          <el-radio v-model="paySetting.radio" label="0">否</el-radio>
          <el-radio v-model="paySetting.radio" label="1">是</el-radio>
          <span  v-show="paySetting.radio === '1'">
              <el-input v-model="paySetting.number" size="mini" class="pay-inp" placeholder="请输入转会费用" @input="paySetting.number = paySetting.number.replace(/[^\d.]/g, '')"></el-input>元
          </span>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button type="primary" plain @click="submit">确定</el-button>
        <el-button plain @click="reset">重置</el-button>
      </div>
    </div>
  </d2-container>
</template>
<script>
export default {
  data () {
    var payNumber = (rule, value, callback) => {
      if (!value) {
        return;
      }
      if (value <= 0) {
        return callback(new Error('您好，金额需要大于0。'));
      } else {
        this.paySetting.number = (this.paySetting.number - 0).toFixed(2);
      }
    };
    return {
      clubSetting: {
        time: null,
        number: null,
        permit: false
      },
      memberSetting: {
        time: null,
        number: null
      },
      paySetting: {
        radio: '0',
        number: null
      },
      payRules: {
        number: [{ validator: payNumber, trigger: 'blur' }]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  methods: {
    submit () {
      let {
        time: tranferClubTime,
        number: tranferCount,
        permit: whetherAllowMemberCreateClub
      } = this.clubSetting;
      let {
        time: tranferMemberTime,
        number: tranferMemberCount
      } = this.memberSetting;
      let { radio: whetherPayTheFee, number: tranferFee } = this.paySetting;
      // 校验
      let tip_arr = [];
      let clubSetting_status = false;
      let memberSetting_status = false;
      let paySetting_status = false;
      if (whetherAllowMemberCreateClub || tranferClubTime || tranferCount) {
        if (tranferClubTime && tranferCount) {
          clubSetting_status = true;
        } else {
          tip_arr.push('俱乐部转会设置');
        }
      }
      if (tranferMemberTime || tranferMemberCount) {
        if (tranferMemberTime && tranferMemberCount) {
          memberSetting_status = true;
        } else {
          tip_arr.push('会员转会设置');
        }
      }
      if (
        whetherPayTheFee === '0' ||
        (whetherPayTheFee === '1' && tranferFee)
      ) {
        paySetting_status = true;
      } else {
        tip_arr.push('转会缴费设置');
      }
      if (tip_arr.length > 0) {
        this.$confirm(`您${tip_arr.join('，')}中，信息未填写完整。`, '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'warning'
        }).then(async () => {});
        return false;
      }
      let data = this.$http.adornData({
        flag: 1,
        tranferClubFlag: clubSetting_status ? 'club_transfer' : null,
        tranferClubStartTime: tranferClubTime && tranferClubTime[0],
        tranferClubEndTime: tranferClubTime && tranferClubTime[1],
        whetherAllowMemberCreateClub: whetherAllowMemberCreateClub ? '1' : '0',
        tranferCount: tranferCount - 0,
        tranferMemberFlag: memberSetting_status ? 'member_transfer' : null,
        tranferMemberStartTime: tranferMemberTime && tranferMemberTime[0],
        tranferMemberEndTime: tranferMemberTime && tranferMemberTime[1],
        tranferMemberCount: tranferMemberCount - 0,
        tranferFeeFlag: paySetting_status ? 'member_fee' : null,
        whetherPayTheFee,
        tranferFee: whetherPayTheFee === '0' ? null : tranferFee
      });
      this.$http({
        url: this.$http.adornUrl('/sys/config/transferConfig'),
        method: 'post',
        data
      }).then(data => {
        if (data && data.code === 0) {
          this.$message.success(data.msg);
        }
      });
    },
    reset () {
      let data = this.$http.adornData({
        flag: 2
      });
      this.$http({
        url: this.$http.adornUrl('/sys/config/transferConfig'),
        method: 'post',
        data
      }).then(data => {
        if (data && data.code === 0) {
          this.clubSetting = {
            time: null,
            number: null,
            permit: false
          };
          this.memberSetting = {
            time: null,
            number: null
          };
          this.paySetting = {
            radio: '0',
            number: null
          };
          this.$message.success('重置成功');
        }
      });
    },
    getSetting () {
      let data = this.$http.adornData({
        flag: 0
      });
      this.$http({
        url: this.$http.adornUrl('/sys/config/transferConfig'),
        method: 'post',
        data
      }).then(data => {
        if (data && data.code === 0) {
          let {
            tranferClubStartTime,
            tranferClubEndTime,
            whetherAllowMemberCreateClub,
            tranferCount,
            tranferMemberStartTime,
            tranferMemberEndTime,
            tranferMemberCount,
            whetherPayTheFee,
            tranferFee
          } = data.data;
          this.clubSetting = {
            time: tranferClubStartTime && [
              tranferClubStartTime,
              tranferClubEndTime
            ],
            number: tranferCount,
            permit:
              whetherAllowMemberCreateClub &&
              whetherAllowMemberCreateClub !== '0'
          };
          this.memberSetting = {
            time: tranferMemberStartTime && [
              tranferMemberStartTime,
              tranferMemberEndTime
            ],
            number: tranferMemberCount
          };
          this.paySetting = {
            radio: whetherPayTheFee !== null ? whetherPayTheFee : '0',
            number: tranferFee
          };
        }
      });
    }
  },
  created () {
    // 查询
    this.getSetting();
  }
};
</script>
<style lang="scss" scoped>
.mb-club {
  overflow: auto;
  .unify-box {
    width: 70%;
    margin: 40px auto 0;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 10px 0 0 0;
    padding: 30px 40px 20px;
    position: relative;
    .title {
      width: 150px;
      font-size: 14px;
      text-align: center;
      background: #fff;
      position: absolute;
      top: -11px;
      left: 50px;
      letter-spacing: 1px;
      margin: 0; //去除默认属性影响
    }
    .gap {
      font-weight: bold;
      color: rgb(16, 16, 16);
      margin: 0 10px;
    }
    .number {
      width: 300px;
    }
    .label {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
      margin-right: 12px;
    }
    .pay-inp {
      width: 200px;
      margin-right: 5px;
    }
    .gap-top {
      margin-top: 20px;
    }
  }
  .btn-box {
    width: 300px;
    display: flex;
    justify-content: space-between;
    margin: 40px auto 0;
    button {
      width: 124px;
    }
  }
}
</style>
<style lang="scss">
.mb-club {
  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      font-weight: bold;
    }
  }
}
</style>
